import React from "react";
import { Flex, Image } from "antd";
import classes from "./til.module.css";

const ThreeImagesLayout = ({ img1, img2, img3 }) => {
  return (
    <Flex
      align={"center"}
      justify={"space-between"}
      className={classes.threeImagesContainer}
    >
      <Flex
        className={classes.imageContainer}
        align={"center"}
        justify={"center"}
      >
        <Image
          src={img1}
          preview={false}
          wrapperStyle={{ width: "100%" }}
          style={{ width: "100%" }}
        />
      </Flex>
      <Flex
        className={classes.imageContainer}
        align={"center"}
        justify={"center"}
      >
        <Image
          src={img2}
          preview={false}
          wrapperStyle={{ width: "100%" }}
          style={{ width: "100%" }}
        />
      </Flex>
      <Flex
        className={classes.imageContainer}
        align={"center"}
        justify={"center"}
      >
        <Image
          src={img3}
          preview={false}
          wrapperStyle={{ width: "100%" }}
          style={{ width: "100%" }}
        />
      </Flex>
      {/*<Flex className={classes.imageContainer2} align={"center"} justify={"center"}>*/}
      {/*    <Image src={img1} preview={false} wrapperStyle={{width: "100%"}} style={{width: "100%"}}/>*/}
      {/*</Flex>*/}
      {/*<Flex className={classes.imageContainer3} align={"center"} justify={"center"}>*/}
      {/*    <Image src={img1} preview={false} wrapperStyle={{width: "100%"}} style={{width: "100%"}}/>*/}
      {/*</Flex>*/}
    </Flex>
  );
};

export default ThreeImagesLayout;
